import React from 'react'
import styled from 'styled-components'

import Colors from 'components/styles/colors'
import { zIndexes } from 'frontend_core/dist/styles/variables'

const Baloon = styled.span`
  position: static;
  text-align: left;
  color: ${Colors.black};
  font-weight: normal;
  line-height: 1.4;
  font-size: 12px;
  display: block;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 3px;
  z-index: ${zIndexes.baloon};

  &::before {
    position: absolute;
    top: -7px;
    left: ${props =>
      props.beakHorizontalPosition ? props.beakHorizontalPosition : '50%'};
    content: ' ';
    margin-left: -8px;
    height: 15px;
    width: 15px;
    background: #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    transform: rotate(45deg);
  }
`
const BaloonInner = styled.span`
  display: block;
  padding: 10px;
  background: #fff;
  border-radius: 3px;
  transform: rotate(0deg);
`

export default (props: Object) => (
  <Baloon {...props}>
    <BaloonInner>{props.text}</BaloonInner>
  </Baloon>
)



// WEBPACK FOOTER //
// ./src/components/atoms/HelpTooltip/index.jsx